import { render, staticRenderFns } from "./GiveRecordDetail.vue?vue&type=template&id=fe2b807c&scoped=true"
import script from "./GiveRecordDetail.vue?vue&type=script&lang=js"
export * from "./GiveRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./GiveRecordDetail.vue?vue&type=style&index=0&id=fe2b807c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2b807c",
  null
  
)

export default component.exports